import { defineStore } from 'pinia';
import { useGlobalToast } from '@/composables/useGlobalToast';



export const useFeedbackStore = defineStore('feedback', () => {
    const { showToast } = useGlobalToast();
    function show(error, data, life = true){
        if(error){
            showToast({
                severity: 'error',
                summary: 'Ocorreu um erro ',
                detail: error.message,
            });
        }else if(!life){
            showToast({
                detail: data
            });
        }else{
            showToast({
                detail: data,
                life: 2000
            });
        }
    }

    return {show}

});
